// Importing images

// Menu Images
import LobsterBisque from "../Assets/Images/menu/lobster-bisque.jpg";
import BreadBarrel from "../Assets/Images/menu/bread-barrel.jpg";
import CrabCake from "../Assets/Images/menu/cake.jpg";
import CaesarSelections from "../Assets/Images/menu/caesar.jpg";
import TuscanGrilled from "../Assets/Images/menu/tuscan-grilled.jpg";
import MozzarellaStick from "../Assets/Images/menu/mozzarella.jpg";
import GreekSalad from "../Assets/Images/menu/greek-salad.jpg";
import SpinachSalad from "../Assets/Images/menu/spinach-salad.jpg";
import LobsterRoll from "../Assets/Images/menu/lobster-roll.jpg";

// Special Item images
import specials1 from "../Assets/Images/specials-1.png";
import specials2 from "../Assets/Images/specials-2.png";
import specials3 from "../Assets/Images/specials-3.png";
import specials4 from "../Assets/Images/specials-4.png";
import specials5 from "../Assets/Images/specials-5.png";

// Gallery Images
import gallery1 from "../Assets/Images/gallery/gallery-1.jpg";
import gallery2 from "../Assets/Images/gallery/gallery-2.jpg";
import gallery3 from "../Assets/Images/gallery/gallery-3.jpg";
import gallery4 from "../Assets/Images/gallery/gallery-4.jpg";
import gallery5 from "../Assets/Images/gallery/gallery-5.jpg";
import gallery6 from "../Assets/Images/gallery/gallery-6.jpg";
import gallery7 from "../Assets/Images/gallery/gallery-7.jpg";
import gallery8 from "../Assets/Images/gallery/gallery-8.jpg";

// Chefs Images
import chef1 from "../Assets/Images/chefs/chefs-1.jpg";
import chef2 from "../Assets/Images/chefs/chefs-2.jpg";
import chef3 from "../Assets/Images/chefs/chefs-3.jpg";

// Menu Items data
export const menuItems = [
	{
		id: "01",
		title: "Lobster Bisque",
		price: "$5.95",
		ingredient: " Lorem, deren, trataro, filede, nerada",
		img: LobsterBisque,
		category: "starters",
	},

	{
		id: "02",
		title: "Bread Barrel",
		price: "$6.95",
		ingredient: "Lorem, deren, trataro, filede, nerada",
		img: BreadBarrel,
		category: "specialty",
	},

	{
		id: "03",
		title: "Crab Cake",
		price: "$7.95",
		ingredient:
			" A delicate crab cake served on a toasted roll with lettuce and tartar sauce",
		img: CrabCake,
		category: "starters",
	},

	{
		id: "04",
		title: "Caesar Selections",
		price: "$8.95",
		ingredient: " Lorem, deren, trataro, filede, nerada",
		img: CaesarSelections,
		category: "salad",
	},

	{
		id: "05",
		title: "Tuscan Grilled",
		price: "$9.95",
		ingredient:
			" Grilled chicken with provolone, artichoke hearts, and roasted red pesto",
		img: TuscanGrilled,
		category: "specialty",
	},

	{
		id: "06",
		title: "Mozzarella Stick",
		price: "$4.95",
		ingredient: " Lorem, deren, trataro, filede, nerada",
		img: MozzarellaStick,
		category: "starters",
	},

	{
		id: "08",
		title: "Greek Salad",
		price: "$9.95",
		ingredient: " Fresh spinach, crisp romaine, tomatoes, and Greek olives",
		img: GreekSalad,
		category: "salad",
	},

	{
		id: "09",
		title: "Spinach Salad",
		price: "$9.95",
		ingredient:
			" Fresh spinach with mushrooms, hard boiled egg, and warm bacon vinaigrette",
		img: SpinachSalad,
		category: "salad",
	},

	{
		id: "10",
		title: "Lobster Roll",
		price: "$12.95",
		ingredient:
			"Plump lobster meat, mayo and crisp lettuce on a toasted bulky roll",
		img: LobsterRoll,
		category: "specialty",
	},
];

// Special items data
export const specialItems = [
	{
		id: 1,
		title: "Architecto ut aperiam autem id",
		note: "Qui laudantium consequatur laborum sit qui ad sapiente dila parde sonata raqer a videna mareta paulona marka",
		description:
			"Et nobis maiores eius. Voluptatibus ut enim blanditiis atque harum sint. Laborum eos ipsum ipsa odit magni. Incidunt hic ut molestiae aut qui. Est repellat minima eveniet eius et quis magni nihil. Consequatur dolorem quaerat quos qui similique accusamus nostrum rem vero",
		img: specials1,
	},

	{
		id: 2,
		title: "Et blanditiis nemo veritatis excepturi",
		note: "Qui laudantium consequatur laborum sit qui ad sapiente dila parde sonata raqer a videna mareta paulona marka",
		description:
			"Ea ipsum voluptatem consequatur quis est. Illum error ullam omnis quia et reiciendis sunt sunt est. Non aliquid repellendus itaque accusamus eius et velit ipsa voluptates. Optio nesciunt eaque beatae accusamus lerode pakto madirna desera vafle de nideran pal",
		img: specials2,
	},

	{
		id: 3,
		title: "Impedit facilis occaecati odio neque aperiam sit",
		note: "Eos voluptatibus quo. Odio similique illum id quidem non enim fuga. Qui natus non sunt dicta dolor et. In asperiores velit quaerat perferendis aut",
		description:
			"Iure officiis odit rerum. Harum sequi eum illum corrupti culpa veritatis quisquam. Neque necessitatibus illo rerum eum ut. Commodi ipsam minima molestiae sed laboriosam a iste odio. Earum odit nesciunt fugiat sit ullam. Soluta et harum voluptatem optio quae",
		img: specials3,
	},

	{
		id: 4,
		title: "Fuga dolores inventore laboriosam ut est accusamus laboriosam dolore",
		note: "Totam aperiam accusamus. Repellat consequuntur iure voluptas iure porro quis delectus",
		description:
			"Eaque consequuntur consequuntur libero expedita in voluptas. Nostrum ipsam necessitatibus aliquam fugiat debitis quis velit. Eum ex maxime error in consequatur corporis atque. Eligendi asperiores sed qui veritatis aperiam quia a laborum inventore",
		img: specials4,
	},

	{
		id: 5,
		title: "Est eveniet ipsam sindera pad rone matrelat sando reda",
		note: "Omnis blanditiis saepe eos autem qui sunt debitis porro quia.",
		description:
			"Exercitationem nostrum omnis. Ut reiciendis repudiandae minus. Omnis recusandae ut non quam ut quod eius qui. Ipsum quia odit vero atque qui quibusdam amet. Occaecati sed est sint aut vitae molestiae voluptate vel",
		img: specials5,
	},
];

// Gallery Data
export const galleryData = [
	{
		id: 1,
		img: gallery1,
		alt: "gallery1",
	},

	{
		id: 2,
		img: gallery2,
		alt: "gallery2",
	},
	{
		id: 3,
		img: gallery3,
		alt: "gallery3",
	},
	{
		id: 4,
		img: gallery4,
		alt: "gallery4",
	},
	{
		id: 5,
		img: gallery5,
		alt: "gallery5",
	},
	{
		id: 6,
		img: gallery6,
		alt: "gallery6",
	},
	{
		id: 7,
		img: gallery7,
		alt: "gallery7",
	},
	{
		id: 8,
		img: gallery8,
		alt: "gallery8",
	},
];

// Chefs Data

export const chefsData = [
	{
		id: 1,
		name: "Walter White",
		role: "Master Chef",
		twitter: "twitter.com/walter-white",
		facebook: "facebook.com/walter-white",
		instagram: "instagram.com/walter-white",
		linkedin: "linkedin.com/walter-white",
		img: chef1,
	},
	{
		id: 2,
		name: "Sarah Jhonson",
		role: "Patissier",
		twitter: "twitter.com/sarah-jhonson",
		facebook: "facebook.com/sarah-jhonson",
		instagram: "instagram.com/sarah-jhonson",
		linkedin: "linkedin.com/sarah-jhonson",
		img: chef2,
	},
	{
		id: 3,
		name: "William Anderson",
		role: "Cook",
		twitter: "twitter.com/william-anterson",
		facebook: "facebook.com/william-anterson",
		instagram: "instagram.com/william-anterson",
		linkedin: "linkedin.com/william-anterson",
		img: chef3,
	},
];
